// UI框架
import React from 'react';
import { connect } from 'react-redux';
import {AuthComponent} from 'publicHOC';
// UI组件
import {Tabs} from 'libs';
// 业务组件
import {LangConsumer} from 'utils/LangProvider';
import {bindLifecycle} from 'utils/bindLifecycle';
import * as mapDispatchToProps from '../../../store/views/AIConfig/IVSTrafficIllegal/controller';
import { clone } from '../../../common';
import TrafficIllegalRegionalConfiguration from './RegionalConfiguration';
import TrafficIllegalRuleConfiguration from './RuleConfiguration';
import TrafficIllegalManualEvidence from './TrafficIllegalManualEvidence';
import WebApp from '../../../webapp';
import TrafficOsd from '../TrafficOsd';
import ViolationCodeConfig from '../IVSIntelliCityMgr/ViolationCodeConfig';
import FileParamConfig from '../IVSIntelliCityMgr/FileParamConfig';
import AdvancedSet from './AdvancedSet';
import RPC from 'api';
// 样式
import './index.less';

const _name_ = 'IVSTrafficIllegalConfig';
const { TabPane } = Tabs;
const sceneType = 'TrafficIllegal';
// 页面需要的数据
const mapStateToProps = (state) => {
    const { IVSTrafficIllegalConfig, publicState } = state;

    return { IVSTrafficIllegalConfig, publicState };
};

class IVSTrafficIllegalConfigComponent extends AuthComponent {
    /** 用来存放组件内状态 */
    constructor (props) {
        super(props);
        this.ComponentName = _name_;
        this.state = {
            key: '1'
        };
        this.intelliTrackerInterval = null; //智能跟踪定时器对象
    }

    componentDidMount () {
        this.timeIntelliTracker();
    }

    componentDidActivate () {
        this.timeIntelliTracker();
    }

    componentWillUnactivate () {
        this.clearTime();
    }

    componentWillUnmount () {
        this.clearTime();
    }

    timeIntelliTracker () {
        if (WebApp.DeviceType.indexOf('SD') > -1) {
            this.intelliTrackerInterval = setInterval(() => {
                if (this.intelliTrackerInterval === 0) {
                    return;
                }
                RPC.devIntelliTrackerManager('stop');
            }, 1000);
        }
    }

    clearTime () {
        if (WebApp.DeviceType.indexOf('SD') > -1) {
            clearInterval(this.intelliTrackerInterval);
            this.intelliTrackerInterval = 0;
            RPC.devIntelliTrackerManager('start');
        }
    }

    handleTabChange = (key) => {
        this.setState({
            key
        });
    }

    render () {
        let {$t, preStep, pageChannels, realPlanType} = this.props;
        let {key} = this.state;
        return (
            <div className={`_${_name_}_`}>
                <Tabs activeKey={key} onTabClick={this.handleTabChange}>
                    <TabPane tab={$t('ivs.AreaConfig')} key="1">
                        {key === '1' ? <TrafficIllegalRegionalConfiguration tabKey={key} keepAlive={false} realPlanType={realPlanType} /> : null}
                    </TabPane>
                    <TabPane tab={$t('ivs.RuleConfig')} key="2">
                        {key === '2' ? <TrafficIllegalRuleConfiguration handleTabChange={this.handleTabChange} tabKey={key} keepAlive={false} realPlanType={realPlanType}/> : null}
                    </TabPane>
                    <TabPane tab={$t('ivs.BreakRulesCode')} key="3">
                        {key === '3' && <ViolationCodeConfig
                            tabKey={key}
                            {...{ preStep, pageChannels, ClassType: sceneType}}
                        />}
                    </TabPane>
                    <TabPane tab={$t('ivs.OriginalDrawingOSD')} key="4">
                        {key === '4' && <TrafficOsd
                            ref={this.TrafficOsd}
                            tabKey={key}
                            {...{ preStep, pageChannels, ClassType: sceneType, osdType: 'OSD', addParams: ['TrafficImage'], supportEditOSDAll: true}}
                        />}
                    </TabPane>
                    <TabPane tab={$t('ivs.CompoundDrawingOSD')} key="5">
                        {key === '5' && <TrafficOsd
                            ref={this.TrafficMergeOSD}
                            tabKey={key}
                            {...{ preStep, pageChannels, curStepOSD: 'ivsTrafficIllegal', ClassType: sceneType, osdType: 'MergeOSD', addParams: ['TrafficImage','TrafficSnapMosaic2'], supportEditOSDAll: true}}
                        />}
                    </TabPane>
                    <TabPane tab={$t('ivs.FileParam')} key="6">
                        {key === '6' && <FileParamConfig
                            tabKey={key}
                            {...{ preStep, pageChannels, ClassType: sceneType}}
                        />}
                    </TabPane>
                    <TabPane tab={$t('ivs.ManualEvidence')} key="7">
                        {key === '7' ? <TrafficIllegalManualEvidence tabKey={key} keepAlive={false} /> : null}
                    </TabPane>
                    <TabPane tab={$t('ivs.AdvancedParams')} key="8">
                        {key === '8' && <AdvancedSet
                            tabKey={key}
                            {...{ preStep, pageChannels, ClassType: sceneType}}
                        />}
                    </TabPane>
                </Tabs>
            </div>
        );
    }
}

export default connect(mapStateToProps,mapDispatchToProps,null,{forwardRef:true})(LangConsumer(bindLifecycle(IVSTrafficIllegalConfigComponent)));